export enum AccountSettingState {
    SaveSuccess = "SaveSuccess",
    SaveFailed = "SaveFailed",
    SavePending = "SavePending",
    Default = ""
}
